import { createBrowserHistory } from 'history';

/**
 * Shared browser history singleton used by <Router> in `App.js` and by
 * REST/GraphQL error interceptors. Using this instead of
 * `window.location.href = '...'` keeps navigations client-side so the app
 * shell (Redux store, Five9 iframe/session, log panel, etc.) is preserved.
 *
 * @type {import('history').History}
 */
const history = createBrowserHistory();

export default history;

